import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useMutation } from "@apollo/react-hooks";
import { Box, Typography } from "@mui/material";
import { ReactComponent as OwTextIcon } from "assets/img/ow-text-icon.svg";
import {
  MyHrLoginTwoFactorRegisterCancel,
  MyHrLoginTwoFactorRegisterWithQrCode,
  MyHrLoginTwoFactorRegisterWithSecretCode,
  MyHrLoginTwoFactorVerifyTotpCode,
} from "my-hr/components";
import { MY_HR_REGISTER_2FA_TOTP } from "my-hr/graphql";
import { useOcCurrentUserState } from "oc/hooks";

interface MyHrLoginTwoFactorTotpRegisterProps {
  onCancel: () => void;
  onForward: () => void;
  isMobile: boolean;
}

export const MyHrLoginTwoFactorTotpRegister = ({
  onCancel,
  onForward,
  isMobile,
}: MyHrLoginTwoFactorTotpRegisterProps) => {
  const { t } = useTranslation();
  const { emailAddress } = useOcCurrentUserState();

  const [data, setData] = useState({
    states: "",
    qrCode: "",
    otpauth_url: "",
    secret: "",
  });
  const [manualSetting, setManualSetting] = useState(false);

  const [registerTotp] = useMutation(MY_HR_REGISTER_2FA_TOTP, {
    onCompleted: (data) => {
      setData(data.register2faTOTP);
    },
    onError: (error) => {
      console.log({ error });
    },
  });

  useEffect(() => {
    registerTotp({
      variables: {
        email: emailAddress,
      },
    });
    // eslint-disable-next-line
  }, []);

  return (
    <Box
      sx={{
        width: isMobile ? "auto" : "304px",
        padding: isMobile ? "0px 24px" : "unset",
      }}
    >
      <OwTextIcon />
      <Typography
        variant="h6"
        sx={{
          marginTop: "24px",
        }}
      >
        {t("MY_HR_2FA_AUTHENTICATION")}
      </Typography>
      {!manualSetting && (
        <MyHrLoginTwoFactorRegisterWithQrCode
          data={data}
          setManualSetting={setManualSetting}
        />
      )}
      {manualSetting && (
        <MyHrLoginTwoFactorRegisterWithSecretCode
          data={data}
          setManualSetting={setManualSetting}
        />
      )}
      <MyHrLoginTwoFactorVerifyTotpCode
        onForward={onForward}
        onCancel={onCancel}
        isRegister={true}
      />
      <MyHrLoginTwoFactorRegisterCancel
        onCancel={onCancel}
        emailAddress={emailAddress}
      />
    </Box>
  );
};

export default MyHrLoginTwoFactorTotpRegister;
